exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".distribut-box[data-v-c3375138]{padding:20px}.el-upload[data-v-c3375138]{float:right;width:120px;margin-right:30px}.el-button--small[data-v-c3375138]{padding:0;width:70px;line-height:36px}.el-input[data-v-c3375138]{width:280px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-c3375138&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/distribut/distribut.vue
// module id = 623
// module chunks = 0